import React, { useState, useEffect } from "react";

export default function BackToTopBtn() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > (100 * window.innerHeight) / 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    setIsClosing(true);
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      setIsClosing(false);
    }, 400);
  };

  return (
    <button
      className={`back-to-top-btn ${isVisible ? "visible" : ""} ${
        isClosing ? "closing" : ""
      }`}
      onClick={scrollToTop}
    >
      <i className="fi fi-bs-angle-small-up"></i>
    </button>
  );
}
